export const libreApi = "https://libre.fm/api/";
export const libre2_0 = "https://libre.fm/2.0/";

export const default_key = "r9i1y91hz71tcx7vyrp9hk1alhqp1888";
export const default_secret = "21dsgf56dfg13df5g46sd85769gt45fd";